import { InterventionTeamLink } from './intervention-team-link';
import { ActionSummary } from './action';
import {ContactSummary} from './contactSummary';
import {pluck} from 'rxjs/operators';

export class InterventionTeam {
  constructor (
    public id: string,
    public label: string,
    public defaultLinks: InterventionTeamLink[],
    public isLinkedToAllBuildings: boolean,
    public isAutoAccept: boolean,
    public buildingIds: string[],
    public actions: ActionSummary[],
    public contacts: ContactSummary[],
    public email: string,
  ) { }

  /**
   * Lite users will have single email for
   * the executor while Pro users will
   * have multiple contacts.
   */
  public get preferredEmail(): string {
    return this.email || this.contacts.find(contact => !!contact.email)?.email;
  }
}
